import React, { useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Collapse from "./templatecollapseMain";
import Sidebar from "./templatecollapse";
import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import refresh_token from "./../../Global/refresh_token";
import GlobalApi from "./../../Global/index";
import DarkButton from "./../../Global/DarkButton";
import LightButton from "./../../Global/LightButton";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Colors from "./../../Global/colors";
import swal from "@sweetalert/with-react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {useTranslation} from 'react-i18next';
const useStyles = makeStyles({
  list: {
    width: 480,
  },
  fullList: {
    width: "auto",
  },
});

export default function SwipeableTemporaryDrawer(props) {
  //var id= props.id;
  //var title=props.title;
  //var description=props.description;
  const { t } = useTranslation();
  const classes = useStyles();
  const [templateId, setTemplateId] = React.useState(props.id);
  const [btnLoader, setBtnLoader] = React.useState(false);
  const [packageDetails, setPackageDetails] = React.useState(null);
  const [btnLoader2, setBtnLoader2] = React.useState(false);
  const history = useHistory();
  const [state, setState] = React.useState({
    right: false,
  });
  const [panel, setPanel] = React.useState([]);
  const [currentCompany, setCurrentCompany] = React.useState();
  const [templateDetails, setTemplateDetails] = React.useState({});
  const [permissions_obj, setPermissionObj] = React.useState({});

  React.useEffect(() => {
    setTemplateId(props.id);
    getPackageDetails();
  }, []);
  let userData = useSelector((state) => state.userReducer.user);

  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
    
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
          

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  let company = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
      setCurrentCompany(company);
      getPermissions();
    },
    [company?.id]
  );

  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };

  const getTemplate = async (templateId) => {
    console.log("GET TEMPLATE DETAILS API CALLED ____________________________");
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return <Redirect to={"/signin"} />;
    }
    //setState({loader:true})

    var params = {
      template_id: templateId,
    };
    //alert(templateId)
    //var token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjIzMWM0YmUxLTU3NmItNDc3Yi05ZGZlLTIwMWYzYWQ0ZmM0ZCIsImVtYWlsIjoiYWJkdWxAZ21haWwuY29tIiwiaWF0IjoxNTk0NjMzMjkyLCJleHAiOjE1OTUzNTMyOTJ9.iJKptiq4-4RGC3PawMAjz2iSeUnGwWhIujgKZJD7zFA'
    var token = data.token;
    let query = Object.keys(params)

      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(GlobalApi + "/Template/get_template_details?" + query, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(
          "GET TEMPLATE DETAILS API RESPONDED ____________________________",
          res
        );
        if (res.status === "Success") {
          var data = res.data;

          var sections = [];
          var orgId = data.organization_id;
          var title = data.title;
          var template_Id = data.id;
          var des = data.description;

          // let templateDetails = ;

          setTemplateDetails({
            title: data.title,
            description: data.description,
            status: "active",
            template_Id: data.id,
          });
          await data.Sections.map((sec) => {
            var checklist = [];
            var checklistTest = [];
            var conditionalList = [];
            sec.CheckLists.map((item) => {
              var responseList = [];

              if (item.data_type == "Custom" || item.data_type == "Global") {
                item.ResponseSets.map((r) => {
                  var item = {
                    id: r.response_id,
                    title: r.title,
                    position: r.position,
                    weight: r.weight,
                  };
                  responseList.push(item);
                });
                var responseLibrary = {
                  id: item.id,
                  responses: responseList.sort(
                    (a, b) => a.position - b.position
                  ),
                };
              }
              if (item.is_conditional == "yes") {
                //alert(JSON.stringify(item))
                //let conditionalItemIndex=sec.CheckLists.findIndex(x=>x.parent_id==item.id)
                //alert(JSON.stringify(sec.CheckLists[conditionalItemIndex]))
                sec.CheckLists.map((cond_item) => {
                  if (cond_item.parent_id == item.id) {
                    //alert(JSON.stringify(cond_item))
                    var newItem = {
                      id: cond_item.id,
                      title: cond_item.title,
                      dataType: cond_item.data_type,
                      position: cond_item.position,
                      status: "New",
                      responseLibrary: cond_item.ResponseSets,
                      mandatory: cond_item.is_mandatory,
                      multiselection: cond_item.is_multiple_allowed,
                      condition: cond_item.condition,
                      conditionValue: cond_item.condition_value,
                      conditional: cond_item.is_conditional,
                      parent: cond_item.parent_id,
                    };
                    conditionalList.push(newItem);
                  }
                });
              }
              var newChecklist = {
                id: item.id,
                title: item.title,
                dataType: item.data_type,
                position: item.position,
                status: "added",
                responseLibrary:
                  item.data_type == "Custom" || item.data_type == "Global"
                    ? responseLibrary
                    : [],
                mandatory: item.is_mandatory,
                multiselection: item.is_multiple_allowed,
                condition: item.condition,
                conditionValue: item.condition_value,
                conditional: item.is_conditional,
                parent: item.parent_id,
                isopen: "no",
                conditionalList: conditionalList,
              };
              checklist.push(newChecklist);
            });
            var sectionList = {
              //  //"template":{"id":sec.id},
              //  "InnerDetails":checklist.sort(function(a, b){return a.position - b.position})
              template: { id: sec.id },
              list: checklist.sort(function(a, b) {
                return a.position - b.position;
              }),
            };

            var section = {
              id: sec.id,
              title: sec.title,
              type: sec.type,
              status: "added",
              position: sec.position,
              checklist: sectionList,
            };

            sections.push(section);
          });
          var blank_template = {
            sections,
          };
          //  await setState({
          //     template:blank_template.sections.sort(function(a, b){return a.position - b.position})
          //     ,loader:false,title:title,orgId:orgId,des:des})
          //alert(JSON.stringify(blank_template))
          await setPanel(
            blank_template.sections.sort(function(a, b) {
              return a.position - b.position;
            })
          );
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();

          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        // alert(err);
        console.log(err, "error");
      });
  };

  const addSection = (
    title,
    template_id,
    user,
    checklist,
    token,
    type,
    position,
    company_id
  ) => {
    var obj = {
      title: title,
      template_id: template_id,
      status: "active",
      created_by: user,
      type: type,
      position: position,
    };
    var token = token;
    console.log("CHECKLIST ARRIVING >>>>>>>>>", checklist);
    fetch(GlobalApi + "/Section/create_section", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          await checklist.map((item) => {
            //alert(JSON.stringify(item.responseLibrary.responses))
            // if (item.status == "New")
            console.log(
              "{}{}{}{}{}{}{}{}{}{}{}{}{}{}{}}[]][][][][][][] Data",
              item.parent,
              item.conditionalList
            );
            addChecklistItem(
              item.title,
              res.data.id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.conditionalList,
              item.type,
              item.is_subquestion,
              item.subQuestionList,
              template_id,
              company_id
            );
          });

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addSection(
              title,
              template_id,
              user,
              checklist,
              token,
              type,
              position,
              company_id
            );
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addChecklistItem = (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    conditionalList = [],
    type,
    is_subquestion,
    subQuestionList = [],
    template_id,
    company_id
  ) => {
    console.log(parent, "opoppopopop");
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);

    var obj = {
      title: title,
      section_id: section_id,
      status: "active",
      created_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      type: type,
      is_subquestion: is_subquestion,
    };
    //alert(JSON.stringify(obj))
    var token = token;
    fetch(GlobalApi + "/CheckList/create_check_list", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        // console.log(res.data);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          if (dataType == "Custom" || dataType == "Global") {
            // ==================  Change of Code ============== //
            for (let item of responseLibrary.responses) {
              addChecklistResponseSet(
                res.data.id,
                item.id,
                template_id,
                company_id,
                item.title,
                item.position,
                item.weight,
                token
              );
            }
          }

          //==================================================//
          //===================== Add Conditional checklist===============//
          if (conditional == "yes") {
            conditionalList.map(async (item) => {
              // if (item.status == "New")∂
              console.log(res.data.id, "hehehehehheheh");
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item.conditionalList,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
              );

              var obj_cond = {
                title: item.title,
                section_id: section_id,
                status: "active",
                created_by: user,
                position: item.position,
                data_type: item.dataType,
                is_mandatory: item.mandatory,
                is_multiple_allowed: item.multiselection,
                condition: item.condition,
                condition_value: item.conditionValue,
                is_conditional: item.conditional,
                parent_id: res.data.id,
                type: item.type,
                is_subquestion: item.is_subquestion,
              };
              //alert(JSON(obj_cond))
              let req_cond = await fetch(
                GlobalApi + "/CheckList/create_check_list",
                {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify(obj_cond),
                }
              );

              let req_cond_json = await req_cond.json();
              if (item.dataType == "Custom" || item.dataType == "Global") {
                // item.responseLibrary.responses.map((r) => {
                //   addResponseLibrary(
                //     r.title,
                //     req_cond_json.data.id,
                //     r.id,
                //     user,
                //     token
                //   );
                // });
                // ==================  Change of Code ============== //
                // if(item.responseLibrary.responses.length >0)
                //   {
                //   addResponseSet(token, data.organization_id, user , template_id,item.responseLibrary.responses,req_cond_json.data.id)
                //   }
                for (let x of item.responseLibrary) {
                  addChecklistResponseSet(
                    req_cond_json.data.id,
                    x.response_id,
                    template_id,
                    company_id,
                    x.title,
                    x.position,
                    x.weight,
                    token
                  );
                }
                // ================================================= //
              }
              console.log("op", req_cond_json.data?.parent_id);
            });
          }


          if (is_subquestion == "yes") {
            subQuestionList.map(async (item) => {
              // if (item.status == "New")∂
              console.log(res.data.id, "hehehehehheheh");
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item.conditionalList,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
              );

              var obj_cond = {
                title: item.title,
                section_id: section_id,
                status: "active",
                created_by: user,
                position: item.position,
                data_type: item.dataType,
                is_mandatory: item.mandatory,
                is_multiple_allowed: item.multiselection,
                condition: item.condition,
                condition_value: item.conditionValue,
                is_conditional: item.conditional,
                parent_id: res.data.id,
                type: item.type,
                is_subquestion: item.is_subquestion,
              };
              //alert(JSON(obj_cond))
              let req_cond = await fetch(
                GlobalApi + "/CheckList/create_check_list",
                {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify(obj_cond),
                }
              );

              let req_cond_json = await req_cond.json();
              if (item.dataType == "Custom" || item.dataType == "Global") {
                // item.responseLibrary.responses.map((r) => {
                //   addResponseLibrary(
                //     r.title,
                //     req_cond_json.data.id,
                //     r.id,
                //     user,
                //     token
                //   );
                // });
                // ==================  Change of Code ============== //
                // if(item.responseLibrary.responses.length >0)
                //   {
                //   addResponseSet(token, data.organization_id, user , template_id,item.responseLibrary.responses,req_cond_json.data.id)
                //   }
                for (let x of item.responseLibrary) {
                  addChecklistResponseSet(
                    req_cond_json.data.id,
                    x.response_id,
                    template_id,
                    company_id,
                    x.title,
                    x.position,
                    x.weight,
                    token
                  );
                }
                // ================================================= //
              }
              console.log("op", req_cond_json.data?.parent_id);
            });
          }

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const addChecklistResponseSet = (
    checkId,
    publicResponseDetailID,
    templateId,
    company_id,
    title,
    position,
    weight,
    token
  ) => {
    var obj = {
      check_id: checkId,
      public_response_Detail_ID: publicResponseDetailID,
      template_id: templateId,
      company_id: company_id,
      title: title,
      position: position,
      weight: weight,
    };
    var token = token;
    fetch(GlobalApi + "/ResponseSet/create-response_set_1", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            addChecklistResponseSet(
              checkId,
              publicResponseDetailID,
              templateId,
              company_id,
              title,
              position,
              weight
            );
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const addResponseSet = (
    token,
    organization,
    user,
    template_id,
    responseSet,
    checkId
  ) => {
    var obj = {
      title: "Custom Response Set",
      company_id: currentCompany.id,
      status: "active",
      created_by: user,
      identifier: "Custom",
      custom_identifier: "Local",
      template_id: template_id,
    };
    var token = token;
    fetch(GlobalApi + "/Response/create_response", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        var responseId = await res.data.id;
        await responseSet.map(async (item, index) => {
          await addResponseDetail(
            token,
            responseId,
            item.title,
            index,
            item.weight,
            checkId,
            user
          );
        });
        // props.refreshResponse();
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            addResponseSet(token, organization);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addResponseDetail = async (
    token,
    responseId,
    title,
    position,
    weight,
    checkId,
    user
  ) => {
    //alert('adding.. response set child info')
    var obj = {
      response_id: responseId,
      title: title,
      weight: weight == "" || weight == undefined ? 0 : weight,
      position: position,
      status: "active",
    };

    var token = token;
    await fetch(GlobalApi + "/ResponseDetail/create_response_detail", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        //var responseId = await res.data.id;
        //await responseSet.map(async (item, index) => {
        //await addResponseDetail(token, responseId, item.title, index,item.weight);
        await addResponseLibrary(
          title,
          checkId,
          responseId,
          user,
          token,
          weight,
          position
        );
        //});

        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            addResponseDetail(token, responseId, title, position, weight);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const addResponseLibrary = (
    title,
    check_id,
    response_id,
    user,
    token,
    weight,
    position
  ) => {
    var obj = {
      title: title,
      check_id: check_id,
      response_id: response_id,
      status: "active",
      created_by: user,
      weight: weight,
      position: position,
    };
    var token = token;
    fetch(GlobalApi + "/ResponseSet/create_response_set", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        // console.log(res.data);
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            // console.log("opopopop");
            addResponseLibrary(title, check_id, response_id, user, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  async function validateResponse(
    responseLibrary,
    template_id,
    token,
    company_id,
    user,
    checkId
  ) {
    let count = 0;

    for (let item of responseLibrary.responses) {
      await IsResponseExist(template_id, item.title, item.weight, token)
        .then((response) => response.json())
        .then((res) => {
          if (res.data == false) {
            //alert('Falsy..')
            count++;
            //break;
          }
        });
    }
    //if(traverseCount == responseLibrary.responses.length){
    if (count > 0) {
      //alert(count)
      addResponseSet(
        token,
        company_id,
        user,
        template_id,
        responseLibrary.responses,
        checkId
      );
    }
  }
  function IsResponseExist(templateId, responseText, responseWeight, token) {
    var obj = {
      templateID: templateId,
      responseSetText: responseText,
      responseSetWeight: responseWeight,
    };
    var token = token;
    return fetch(GlobalApi + "/ResponseSet/check_response_set_existance", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    });

    //alert(JSON.stringify(res))
    //return res
    // .then((response) => response.json())
    // .then(async (res) => {
    //   alert(res.data)
    //  return res.data
    // if (res.status === "Success") {
    //   alert(res.data)
    //   return res.data
    // } else if (
    //   res.error === "jwt expired" ||
    //   res.error === "invalid token" ||
    //   res.error === "invalid signature" ||
    //   res.error == "Unexpected token"
    // ) {
    //   let status = await refresh_token();

    //   if (status) {

    //     IsResponseExist(templateId,responseText,responseWeight);
    //   }
    // }
    // })
    // .catch((err) => {
    //   console.log(err, "error");
    //   return false
    // });
  }
  //  React.useState(()=>{
  //    //alert(props.id)
  //    getTemplate(props.id)
  //  })
  const toggleDrawer = (anchor, open) => (event) => {
    // if (
    //   event &&
    //   event.type === "keydown" &&
    //   (event.key === "Tab" || event.key === "Shift")
    // ) {
    //   return;
    // }
    getTemplate(props.id);
    console.log(anchor, open);
    setState({ ...state, [anchor]: open });
  };

  const handleBack = async (template) => {
    setBtnLoader(true);
    console.log("Btn Loader Called on handele back");
    console.log();
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return <Redirect to={"/signin"} />;
    }

    var user = data.user_id;
    var obj = {
      title: templateDetails.title,
      //organization_id:'408576c3-0471-467e-9f55-f4c44bb54c6e',
      company_id: currentCompany.id,
      description: templateDetails.title.description,
      status: "active",
      created_by: user,
      public_template_id: templateDetails.template_Id,
    };
    var token = data.token;
    console.log("First Api called");
    fetch(GlobalApi + "/Template/create_template", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("First Api Responded", res);
        if (res.msg === "success") {
          console.log("Second Api Called");
          await fetch(GlobalApi + "/TemplateShare/create_template_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              user_id: user,
              company_id: currentCompany.id,
              template_id: res.data.id,
              isOwner: true,
              isEditor: true,
            }),
          })
            .then((responseShare) => responseShare.json())
            .then(async (resShare) => {
              console.log("Second Api Responded", resShare);
              console.log("Third Api called");

              await fetch(
                GlobalApi + "/ResponseSet/create_response_public_to_private",
                {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({
                    public_template_id: templateId,
                    company_id: currentCompany.id,
                    template_id: res.data.id,
                  }),
                }
              )
                .then((responseShare) => responseShare.json())
                .then(async (resShare) => {
                  console.log("Third Api Responded", resShare);
                });
            });
          console.log("tmplate before");
          await template.map((section, index) => {
            console.log("tmplate number ", index + 1);
            // if (section.status == "New")
            addSection(
              section.title,
              res.data.id,
              user,
              section.checklist.list,
              token,
              section.type,
              section.position,
              currentCompany.id
            );
          });

          console.log("tmplate after");

          setTimeout(() => {
            swal(t("Success"), t("Template Added Successfully"), "success");

            history.push({
              pathname: "/show",
              state: { action: "edit", templateId: res.data.id },
            });
          }, 3000);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            handleBack();
          }
        } else if (res.msg == "error") {
          swal(t("Error"), res.error, "error");
          setBtnLoader(false);
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  // Handle Back End

  //// Directly add template and {t("start schedule")}
  const createScheduleDirect = async (template) => {
    console.log("INCOMING TEMPLATE >>>>>>>>>>>", template);
    console.log("INCOMING TEMPLATE >>>>>>>>>>>", template);
    setBtnLoader2(true);
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return <Redirect to={"/signin"} />;
    }

    console.log("template details", templateDetails);

    var user = data.user_id;
    var obj = {
      title: templateDetails.title,
      //organization_id:'408576c3-0471-467e-9f55-f4c44bb54c6e',
      company_id: currentCompany.id,
      description: templateDetails.description,
      status: "active",
      created_by: user,
      public_template_id: templateDetails.template_Id,
    };
    var token = data.token;
    console.log("First Api called", templateDetails.template_Id);
    fetch(GlobalApi + "/Template/create_template", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("First Api Responded", res);
        if (res.msg === "success") {
          console.log("Second Api Called");
          await fetch(GlobalApi + "/TemplateShare/create_template_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              user_id: user,
              company_id: currentCompany.id,
              template_id: res.data.id,
              isOwner: true,
              isEditor: true,
            }),
          })
            .then((responseShare) => responseShare.json())
            .then(async (resShare) => {
              console.log("Second Api Responded", resShare);
              console.log("Third Api called");

              await fetch(
                GlobalApi + "/ResponseSet/create_response_public_to_private",
                {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({
                    public_template_id: templateId,
                    company_id: currentCompany.id,
                    template_id: res.data.id,
                  }),
                }
              )
                .then((responseShare) => responseShare.json())
                .then(async (resShare) => {
                  console.log("Third Api Responded", resShare);
                });
            });
          console.log("BEFORE____________________________");
          await template.map((section, index) => {
            console.log("section number", index + 1);
            addSection(
              section.title,
              res.data.id,
              user,
              section.checklist.list,
              token,
              section.type,
              section.position,
              currentCompany.id
            );
          });

          console.log("AFTER____________________________");
          setTimeout(() => {
            swal(t("Success"), t("Template Added Successfully"), "success");
            history.push({
              pathname: "/schedule-create",
              state: { template_id: res.data.id },
            });
            setBtnLoader2(false);
          }, 3000);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            createScheduleDirect(template);
          }
        } else if (res.msg == "error") {
          swal(t("Error"), res.error, "error");
          setBtnLoader2(false);
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  // {t("Start schedule")}  End

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Divider />
    </div>
  );
  {
    /* <Link to="/show" params={{ testvalue: "hello" }}> */
  }

  // console.log(panel)
  return (
    <div style={{ width: "100%" }}>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          {props.isDisabled ? (
            <LightButton
              disabled={props.isDisabled}
              onClick={toggleDrawer(anchor, true)}
            >
              Featured 1
            </LightButton>
          ) : (
            <Button
              size="small"
              className="addTempBtn"
              onClick={toggleDrawer(anchor, true)}
              style={{
                backgroundColor: Colors.globalColor8,
                padding: "50px  auto",
                color: Colors.globalColor8,
                width: "100%",
              }}
            >
              {t("use this template")}
            </Button>
          )}
          {state[anchor] && (
            <SwipeableDrawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
              className="sidebar-swap"
              style={{ padding: "20px" }}
            >
              <div
                style={{
                  padding: "30px",
                  backgroundColor: Colors.globalColor4,
                }}
              >
                {/* {list(anchor)} */}
                <Grid container justify="center" alignItems="center">
                  <Grid item xs={6}>
                    <p
                      style={{
                        color: Colors.globalColor8,
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                      onClick={toggleDrawer(anchor, true)}
                    >
                      {t("Preview")}
                    </p>
                  </Grid>
                  <Grid item xs={6} style={{ textAlign: "right" }}>
                    <p
                      onClick={() => {
                        setState({ ...state, right: false });
                      }}
                      style={{
                        color: Colors.globalColor8,
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      X
                    </p>
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  {packageDetails?.template_limit !== "Unlimited" && <>
                  {packageDetails?.template_limit > packageDetails?.template_count ? (
                    <>
                      {" "}
                      <Grid item xs={6}>
                        {panel.length > 0 &&
                        (userData?.super_admin == true ||
                          permissions_obj["Admin"] == true ||
                          permissions_obj["Template Creation"] == true) ? (
                          <Button
                          className="addBtn"
                            style={{
                              margin: 5,
                              width: "100%",
                              backgroundColor: Colors.globalColor8,
                            }}
                            onClick={() => {
                              handleBack(panel);
                            }}
                          >
                            {btnLoader === true && (
                              <CircularProgress
                                size={18}
                                style={{ color: "white", marginRight: 7 }}
                              />
                            )}
                            {t("Add to My Templates")}
                          </Button>
                        ) : (
                          <Button
                            style={{
                              margin: 5,
                              width: "100%",
                              backgroundColor: "#dadada",
                            }}
                            disabled
                          >
                            {btnLoader === true && (
                              <CircularProgress
                                size={18}
                                style={{ color: "white", marginRight: 7 }}
                              />
                            )}
                            {t("Add to My Templates")}
                          </Button>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        {panel.length > 0 &&
                        (userData?.super_admin == true ||
                          permissions_obj["Admin"] == true ||
                          permissions_obj["Template Creation"] == true) ? (
                          <Button
                            style={{
                              borderWidth: "2px",
                              borderStyle: "solid",
                              fontWeight: "bold",
                              textTransform: "capitalize",
                              borderColor: Colors.globalColor8,
                              margin: 0,
                              width: "100%",
                              color: Colors.globalColor8,
                              backgroundColor: "white",
                            }}
                            onClick={() => {
                              createScheduleDirect(panel);
                            }}
                          >
                            {btnLoader2 === true && (
                              <CircularProgress
                                size={16}
                                style={{
                                  color: Colors.globalColor8,
                                  marginRight: 7,
                                }}
                              />
                            )}
                            {t("Start Schedule")}
                          </Button>
                        ) : (
                          <Button
                            disabled
                            style={{
                              borderWidth: "2px",
                              borderStyle: "solid",
                              fontWeight: "bold",
                              textTransform: "capitalize",
                              borderColor: "#dadada",
                              margin: 0,
                              width: "100%",
                              color: "#dadada",
                              backgroundColor: "white",
                            }}
                          >
                            {btnLoader2 === true && (
                              <CircularProgress
                                size={18}
                                style={{
                                  color: Colors.globalColor8,
                                  marginRight: 7,
                                }}
                              />
                            )}
                            {t("Start Schedule")}
                          </Button>
                        )}
                      </Grid>
                    </>
                  ) : (
                    <Grid item xs={12}>
                      <Link to="/update_package">
                        <DarkButton
                          style={{
                            margin: 5,
                            width: "100%",
                            backgroundColor: Colors.globalColor8,
                          }}
                        >
                          {"Upgrade Package"}
                        </DarkButton>
                      </Link>
                    </Grid>
                  )}
                  </>}

                  {packageDetails?.template_limit === "Unlimited" && <>
                      {" "}
                      <Grid item xs={6}>
                        {panel.length > 0 &&
                        (userData?.super_admin == true ||
                          permissions_obj["Admin"] == true ||
                          permissions_obj["Template Creation"] == true) ? (
                          <DarkButton
                            style={{
                              margin: 5,
                              width: "100%",
                              backgroundColor: Colors.globalColor8,
                            }}
                            onClick={() => {
                              handleBack(panel);
                            }}
                          >
                            {btnLoader === true && (
                              <CircularProgress
                                size={18}
                                style={{ color: "white", marginRight: 7 }}
                              />
                            )}
                            {t("Add to My Templates")}
                          </DarkButton>
                        ) : (
                          <Button
                            style={{
                              margin: 5,
                              width: "100%",
                              backgroundColor: "#dadada",
                            }}
                            disabled
                          >
                            {btnLoader === true && (
                              <CircularProgress
                                size={18}
                                style={{ color: "white", marginRight: 7 }}
                              />
                            )}
                            {t("Add to My Templates")}
                          </Button>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        {panel.length > 0 &&
                        (userData?.super_admin == true ||
                          permissions_obj["Admin"] == true ||
                          permissions_obj["Template Creation"] == true) ? (
                          <Button
                            style={{
                              borderWidth: "2px",
                              borderStyle: "solid",
                              fontWeight: "bold",
                              textTransform: "capitalize",
                              borderColor: Colors.globalColor8,
                              margin: 5,
                              width: "100%",
                              color: Colors.globalColor8,
                              backgroundColor: "white",
                            }}
                            onClick={() => {
                              createScheduleDirect(panel);
                            }}
                          >
                            {btnLoader2 === true && (
                              <CircularProgress
                                size={18}
                                style={{
                                  color: Colors.globalColor8,
                                  marginRight: 7,
                                }}
                              />
                            )}
                            {t("Start Schedule")}
                          </Button>
                        ) : (
                          <Button
                            disabled
                            style={{
                              borderWidth: "2px",
                              borderStyle: "solid",
                              fontWeight: "bold",
                              textTransform: "capitalize",
                              borderColor: "#dadada",
                              margin: 5,
                              width: "100%",
                              color: "#dadada",
                              backgroundColor: "white",
                            }}
                          >
                            {btnLoader2 === true && (
                              <CircularProgress
                                size={18}
                                style={{
                                  color: Colors.globalColor8,
                                  marginRight: 7,
                                }}
                              />
                            )}
                            {t("Start Schedule")}
                          </Button>
                        )}
                      </Grid>
                    </>}

                  
                </Grid>
              </div>

              <div style={{ padding: "30px" }}>
                <Sidebar HOCprops={panel} />
              </div>
            </SwipeableDrawer>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
